// TODO check with be which statuses are related to old booking and remove them
export enum PaymentStatus {
  OUT_OF_POLICY = 'OUT_OF_POLICY',
  APPROVAL_NEEDED = 'APPROVAL_NEEDED',
  PAYABLE = 'PAYABLE',
  COMPLETED_BY_AGENT = 'COMPLETED_BY_AGENT',
  APPROVAL_ACCEPTED = 'APPROVAL_ACCEPTED',
  APPROVAL_APPROVED = 'APPROVAL_APPROVED',
  APPROVAL_PENDING = 'APPROVAL_PENDING',
  APPROVAL_REJECTED = 'APPROVAL_REJECTED',
  DRAFT = 'DRAFT',
  LOCKED = 'LOCKED',
  COMPLETED = 'COMPLETED',
  PROCESSING_PURCHASE = 'PROCESSING_PURCHASE',
  REFUNDED = 'REFUNDED',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  COMPLETED_EMPTY = 'COMPLETED_EMPTY',
  PENDING = 'PENDING',
  DONE = 'DONE',
  EMPTY = 'EMPTY',
  DELETABLE = 'DELETABLE',
  SEND_GO_REQUEST = 'SEND_GO_REQUEST',
  UNDEFINED = 'UNDEFINED',
  DIFFERENT_PAYMENT = 'DIFFERENT_PAYMENT',
  REJECTED = 'REJECTED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  ORDER_PROCESSING = 'ORDER_PROCESSING',
  PAY_NOW = 'PAY_NOW',
}
